

export const veoShowcase = {
    header: 'AI 生成影片',
    badge: 'AI 影片',
    title: '文字轉影片',
    subtitle:
      '以詳細文字描述傳達創意，生成電影級內容，具備原生音訊與逼真動態效果',
    promptLabel: '提示詞',
    promptText:
      '一段極具電影質感的無人機空拍鏡頭，從夜幕降臨、霓虹閃爍的未來都市雨景全景開始，流暢地滑翔至一隻閃耀著藍光的蝴蝶落在濕漉漉的金屬欄桿上的特寫。蝴蝶落地時，翅膀閃爍著光芒，完美地映照在雨滴中。鏡頭運動流暢專業，動態模糊效果逼真，背景虛化效果極佳。 8K分辨率，紋理細節豐富，色彩鮮豔，充滿賽博龐克風格。'
  };
